// Feelgood: "Ansehen"-Button auf den Listing-Karten von Varianten-Artikeln
// entfernen (Kundenwunsch 2026-10-21). Die Farbpunkte rechts bleiben.
//
// SCOPE: Nur im Shop. Die Karten werden clientseitig gerendert und bei jedem
// Filterwechsel neu; deshalb patchen wir render_result des
// variant-colours-Moduls (wird von webshop_view.js nach JEDER Listenrenderung
// aufgerufen) und entfernen nach dem Original die Buttons. Ausserdem ein
// MutationObserver auf #product-listing als Netz, falls ein Renderpfad den
// Hook umgeht.
//
// Entfernt wird die ganze Wrapper-Kette des Buttons (a + .mt-3), nicht nur
// display:none - so bleibt die Flex-Reihe mit den Farbpunkten unveraendert.
(function () {
	function removeExploreButtons() {
		document.querySelectorAll("#product-listing a .btn-explore-variants").forEach(function (btn) {
			var a = btn.closest("a");
			if (!a) { btn.remove(); return; }
			// aeussersten Wrapper innerhalb der Bottom-Row/Karte finden
			var node = a;
			var bottomRow = btn.closest(".ws-bottom-row");
			var container = bottomRow || btn.closest(".card") || document;
			while (node.parentElement && node.parentElement !== container) {
				node = node.parentElement;
			}
			node.remove();
		});
	}

	var hooked = false;
	function hookRenderResult() {
		if (hooked) return;
		if (window.webshop && webshop.variant_colours && webshop.variant_colours.render_result) {
			var orig = webshop.variant_colours.render_result;
			webshop.variant_colours.render_result = function (items) {
				var res = orig.apply(this, arguments);
				removeExploreButtons();
				return res;
			};
			hooked = true;
		}
	}

	function start() {
		hookRenderResult();
		removeExploreButtons();
		var target = document.getElementById("product-listing");
		if (target && window.MutationObserver) {
			new MutationObserver(removeExploreButtons).observe(target, { childList: true, subtree: true });
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
})();
